/**
 * Определяет, является ли сегмент код-шеринговым.
 *
 * Код-шеринг означает, что маркетинговый перевозчик (marketingAirline)
 * отличается от фактического (operatingAirline).
 *
 * @param segment - Сегмент рейса.
 * @returns true, если сегмент является код-шеринговым; иначе false.
 *
 */
export const isCodeShared = (segment) => {
    var _a, _b;
    return ((_a = segment === null || segment === void 0 ? void 0 : segment.operatingAirline) === null || _a === void 0 ? void 0 : _a.iata) !== ((_b = segment === null || segment === void 0 ? void 0 : segment.marketingAirline) === null || _b === void 0 ? void 0 : _b.iata);
};
/**
 * Проверяет, есть ли среди сегментов хотя бы один код-шеринговый.
 *
 * Проверяет функцией {@link isCodeShared}.
 *
 * @param segments - Массив сегментов.
 * @returns true, если найден хотя бы один код-шеринговый сегмент; иначе false.
 */
export const hasCodeSharedSegments = (segments) => {
    return segments === null || segments === void 0 ? void 0 : segments.some(isCodeShared);
};
